import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00df43fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "feature",
  name: "feature"
}
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, {
        level: 1,
        "data-aos": "fade-down"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Featured products drive higher business value ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_tabs, {
        activeKey: $data.tab.active,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (($data.tab.active) = $event)),
        "data-aos": "fade-up",
        centered: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: index+1,
              tab: item.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: _normalizeClass([`t_${index+1}`,$data.tab.show===index+1?'tab_show':''])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      lg: 14
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item", `i_${index+1}`])
                        }, [
                          (item.title)
                            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                key: 0,
                                level: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          _createVNode(_component_a_typography_paragraph, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ], 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_a_col, {
                      xs: 0,
                      lg: 10
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["media", `m_${index+1}`])
                        }, null, 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["activeKey"])
    ])
  ]))
}